import Vue from 'vue'

import VueHead from 'vue-head'
Vue.use(VueHead)
// hash变化刷新页面
window.onhashchange = function () {
  window.location.reload()
}
/**
 * 解析参数成对象
 * @param arrStr 例：a=17&b=2
 * @returns url参数对象
 */
function dealQueryParams (arrStr) {
  if (!arrStr) return {}
  let params = Object.create(null)
  if (arrStr.length > 1) {
    let arrObj = arrStr.split('&')
    arrObj.forEach(item => {
      item = item.split('=')
      params[item[0]] = item[1]
    })
  }
  return params
}

function getHashCode () {
  return (location.hash || '').split('?')[0].split('#/')[1]
}

function getHashParams () {
  let paramStr = (location.hash || '').split('?')[1]
  return dealQueryParams(paramStr)
}

function getUrlParam () {
  let url = document.location.search
  let paramStr = url.split('?')[1]
  return dealQueryParams(paramStr)
}
const hashCode = getHashCode()
const params = getUrlParam()
const hashParams = getHashParams()

window.topicParams = hashCode ? Object.assign({}, params, hashParams, { code: hashCode }) : params
